import MuiLink from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

/**
 * In-grid navigation link: stops event propagation so DataGrid row selection does not fire.
 */
export default function DatagridNavLink({ to, children, sx }) {
  if (!to) {
    return <span>{children ?? "—"}</span>;
  }
  return (
    <MuiLink
      component={RouterLink}
      to={to}
      onClick={(e) => e.stopPropagation()}
      underline="always"
      sx={(theme) => ({
        fontWeight: 700,
        cursor: "pointer",
        color: theme.palette.primary.main,
        textDecorationColor: theme.palette.primary.main,
        textUnderlineOffset: "2px",
        "&:hover": {
          textDecorationThickness: "max(2px, 0.08em)",
        },
        ...sx,
      })}
    >
      {children}
    </MuiLink>
  );
}
